export function getNumberFromSearchParam(searchParam: string | null): number | undefined {
  if (typeof searchParam !== 'string' || searchParam === '') return undefined

  const int = Number.parseInt(searchParam)
  if (Number.isNaN(int))
    return undefined

  return int;
}
